import { memo } from 'react';
import {
  Stack,
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Typography,
  Icon
} from 'investira.react.components';
import AtivosChart from './AtivosChart';
import EmissoresChart from './EmissoresChart';
import SetoresChart from './SetoresChart';
import GestoresChart from './GestoresChart';

const Graphs = memo(props => {
  const { isLoading } = props;
  const { ativos = [], emissores = [], gestores = [], setores = [] } = props.data || {};

  return (
    <Stack
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(1, 1fr)',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(2, 1fr)',
          xl: 'repeat(2, 1fr)'
        },
        justifyContent: 'space-between',
        gap: 1.5
      }}>
      {isLoading ? (
        Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width="100%"
            height="260px"
            sx={{ borderRadius: 2 }}
          />
        ))
      ) : (
        <>
          <Card sx={{ flexGrow: 1, minHeight: 0 }}>
            <CardHeader
              title={
                <Stack direction="row" alignItems="center" gap={2}>
                  <Icon iconName="chart_pizza" color="secondaryLightness" size={21} />
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Tipos de Ativos
                  </Typography>
                </Stack>
              }
            />
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: 0
              }}>
              <AtivosChart data={ativos} />
            </CardContent>
          </Card>
          <Card sx={{ flexGrow: 1, minHeight: 0 }}>
            <CardHeader
              title={
                <Stack direction="row" alignItems="center" gap={2}>
                  <Icon iconName="chart_pizza" color="secondaryLightness" size={21} />
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Setores
                  </Typography>
                </Stack>
              }
            />
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: 0
              }}>
              <SetoresChart data={setores} />
            </CardContent>
          </Card>

          <Card sx={{ flexGrow: 1, minHeight: 0 }}>
            <CardHeader
              title={
                <Stack direction="row" alignItems="center" gap={2}>
                  <Icon iconName="chart_pizza" color="secondaryLightness" size={21} />
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Emissores
                  </Typography>
                </Stack>
              }
            />
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: 0
              }}>
              <EmissoresChart data={emissores} />
            </CardContent>
          </Card>
          <Card sx={{ flexGrow: 1, minHeight: 0 }}>
            <CardHeader
              title={
                <Stack direction="row" alignItems="center" gap={2}>
                  <Icon iconName="chart_pizza" color="secondaryLightness" size={21} />
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Gestores
                  </Typography>
                </Stack>
              }
            />
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: 0
              }}>
              <GestoresChart data={gestores} />
            </CardContent>
          </Card>
        </>
      )}
    </Stack>
  );
});

export default Graphs;
